"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function AboutPreview() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="about-preview" className="bg-background py-20 lg:py-28">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div ref={textRef} className={`space-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${textVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="space-y-4">
              <div className="w-16 h-1 bg-accent" />
              <h2 className="font-display text-4xl lg:text-5xl font-bold text-foreground leading-tight">
                Your Trusted Partner in Global Trade
              </h2>
            </div>
            <p className="text-muted-foreground text-lg leading-relaxed">
              At Global Wholesale Trade, we connect buyers with verified suppliers across continents, ensuring quality, transparency, and reliability at every step. From sourcing to delivery, we handle the complexities of international trade so you can focus on growing your business.
            </p>
            <p className="text-muted-foreground text-lg leading-relaxed">
              With regional expertise spanning the Middle East, Africa, Asia, and Europe, we deliver commodities that meet rigorous quality standards and arrive on time, every time.
            </p>
          </div>

          {}
          <div ref={imageRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${imageVisible ? "opacity-100 scale-100" : "opacity-0 scale-98"}`}>
            <Card className="overflow-hidden shadow-medium">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/professional_trade_meeting.png" alt="Professional trade meeting between global partners" className="w-full h-auto object-cover" />
            </Card>
          </div>
        </div>
      </div>
    </section>;
}